import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { RtUICoreModule } from '../core/core.module';
import { AddLineComponent } from './add-line/add-line.component';
import { AdminsAvatarsModule } from './admins-avatars/admins-avatars.module';
import { AdminsSelectDialogFormModule } from './admins-select-dialog-form/admins-select-dialog-form.module';
import { AvatarComponent } from './avatar/avatar.component';
import { BadgeComponent } from './badge/badge.component';
import { BoxComponent } from './box/box.component';
import { AddNewButtonComponent } from './button/components/add-new-button/add-new-button.component';
import { ButtonComponent } from './button/components/button/button.component';
import { IconButtonComponent } from './button/components/icon-button/icon-button.component';
import { PlanButtonComponent } from './button/components/plan-button/plan-button.component';
import { ButtonDropdownIndicatorDirective } from './button/directives/button-dropdown/button-dropdown-indicator.directive';
import { ButtonLoadingDirective } from './button/directives/button-loading/button-loading.directive';
import { CandidateRatingComponent } from './candidate-rating/candidate-rating.component';
import { CandidatesAvatarsModule } from './candidates-avatars/candidates-avatars.module';
import { CardComponent } from './card/card.component';
import { CircularProgressIndicatorComponent } from './circular-progress-indicator/circular-progress-indicator.component';
import { DateModule } from './date/date.module';
import { DividerComponent } from './divider/divider.component';
import { DotComponent } from './dot/dot.component';
import { PreventDragDropDirective } from './drag-and-drop/prevent-dragdrop.directive';
import { DropdownHeaderComponent } from './dropdown/dropdown-header/dropdown-header.component';
import { DropdownItemComponent } from './dropdown/dropdown-item/dropdown-item.component';
import { NestedTemplateTriggerDirective } from './dropdown/dropdown-nested-templates/nested-template-trigger.directive';
import { DropdownComponent } from './dropdown/dropdown.component';
import { EmptyStateComponent } from './empty-state/empty-state.component';
import { FabButtonComponent } from './fab-button/fab-button.component';
import { GroupComponent } from './group/group.component';
import { HeadingComponent } from './heading/heading.component';
import { HotkeyComponent } from './hotkey/hotkey.component';
import { IconHelpComponent } from './icon-help/icon-help.component';
import { IconComponent } from './icon/icon.component';
import { InterviewEvaluationRatingModule } from './interview-evaluation-rating/interview-evaluation-rating.module';
import { ItemComponent } from './item/item.component';
import { LabelComponent } from './label/label.component';
import { ListComponent } from './list/list.component';
import { MailPickerComponent } from './mail-picker/mail-picker.component';
import { MessageComponent } from './message/message.component';
import { OfferStatusIndicatorComponent } from './offer-status-indicator/offer-status-indicator.component';
import { PaginationCounterModule } from './pagination-counter/pagination-counter.module';
import { PaginationComponent } from './pagination/pagination.component';
import { PipesModule } from './pipes/pipes.module';
import { PlaceloaderComponent } from './placeloader/placeloader.component';
import { ProgressBarComponent } from './progress-bar/progress-bar.component';
import { ProgressComponent } from './progress/progress.component';
import { ResultsLimitButtonModule } from './results-limit-button/results-limit-button.module';
import { SegmentedControlButtonModule } from './segmented-control/segmented-control-button/segmented-control-button.module';
import { SegmentedControlModule } from './segmented-control/segmented-control.module';
import { SpinnerComponent } from './spinner/spinner.component';
import { TableComponent } from './table/table.component';
import { TabsModule } from './tabs/tabs.module';
import { TagComponent } from './tag/tag.component';
import { ToolbarGroupComponent } from './toolbar/toolbar-group/toolbar-group.component';
import { ToolbarPrimaryComponent } from './toolbar/toolbar-primary/toolbar-primary.component';
import { ToolbarSecondaryComponent } from './toolbar/toolbar-secondary/toolbar-secondary.component';
import { ToolbarComponent } from './toolbar/toolbar/toolbar.component';
import { TooltipModule } from './tooltip/tooltip.module';
import { TruncateComponent } from './truncate/truncate.component';

const COMPONENT_MODULES = [
  TabsModule,
  TooltipModule,
  DateModule,
  AdminsAvatarsModule,
  AdminsSelectDialogFormModule,
  CandidatesAvatarsModule,
  InterviewEvaluationRatingModule,
  PaginationCounterModule,
  SegmentedControlButtonModule,
  SegmentedControlModule,
  ResultsLimitButtonModule,

  AvatarComponent,
  BadgeComponent,
  BoxComponent,
  CardComponent,
  IconComponent,
  SpinnerComponent,
  EmptyStateComponent,
  DividerComponent,

  DotComponent,
  MessageComponent,
  AddLineComponent,

  ButtonComponent,
  ButtonDropdownIndicatorDirective,
  ButtonLoadingDirective,
  IconButtonComponent,
  PlanButtonComponent,
  AddNewButtonComponent,
  CandidateRatingComponent,
  CircularProgressIndicatorComponent,
  PreventDragDropDirective,
  DropdownComponent,
  DropdownItemComponent,
  DropdownHeaderComponent,
  NestedTemplateTriggerDirective,
  HeadingComponent,
  HotkeyComponent,
  GroupComponent,
  TruncateComponent,
  IconHelpComponent,
  ItemComponent,
  LabelComponent,
  ListComponent,
  MailPickerComponent,
  OfferStatusIndicatorComponent,
  PaginationComponent,
  PlaceloaderComponent,
  ProgressComponent,
  ProgressBarComponent,
  TableComponent,
  TagComponent,
  ToolbarComponent,
  ToolbarGroupComponent,
  ToolbarPrimaryComponent,
  ToolbarSecondaryComponent,
  FabButtonComponent,
];

@NgModule({
  imports: [FormsModule, ReactiveFormsModule, RtUICoreModule, PipesModule, ...COMPONENT_MODULES],
  exports: [FormsModule, ReactiveFormsModule, RtUICoreModule, PipesModule, ...COMPONENT_MODULES],
})
export class RtUICommonModule {}
